import { useState } from "react";
import "./Itinerary2.css";
import Day1Card from "./day1_card/Day1_Card";
import Day2Card from "./day2_card/Day2_Card";
import Day3Card from "./day3_card/Day3_Card";
import { Nav, Tab } from "react-bootstrap";
import Itinerary_Tab from "./inner_tabs/itinerary_tab/Itinerary_Tab";
import Summarised_View from "./inner_tabs/summarised_view/Summarised_View";
import Activity_Tab from "./inner_tabs/activity_tab/Activity_Tab";
import Flights from "./inner_tabs/flights/Flights";
import Stay from "./inner_tabs/stay/Stay";
import Transfers from "./inner_tabs/transfers/Transfers";

const icons = {
  meal: "/assets/images/cruise/itenarary/day-meal.png",
  checkout: "/assets/images/cruise/itenarary/checkout.png",
  car: "/assets/images/cruise/itenarary/private-tranfer.png",
  bed: "/assets/images/cruise/itenarary/bed-img.png",
  map: "/assets/images/cruise/itenarary/activity.png",
  flight: "/assets/images/cruise/itenarary/flight1.png",
};

function Itinerary2({ data }) {
  const tabs = [
    "Itinerary",
    "Summarised View",
    "Activities",
    "Flights",
    "Stay",
    "Transfers",
  ];
  return (
    <div className="itinerary_wrapper">
      <div className="structure_tabs">
        <Tab.Container id="sem-tabs" defaultActiveKey={tabs[0]}>
          <Nav variant="pills" className="">
            {tabs.map((tab, index) => (
              <Nav.Item>
                <Nav.Link eventKey={tab}>{tab}</Nav.Link>
              </Nav.Item>
            ))}
          </Nav>

          <Tab.Content className="inner-tab-sec">
            <Tab.Pane eventKey="Itinerary">
              <Itinerary_Tab data={data} />
            </Tab.Pane>

            <Tab.Pane eventKey="Summarised View">
              <Summarised_View data={data} />
            </Tab.Pane>

            <Tab.Pane eventKey="Activities">
              <Activity_Tab data={data} />
            </Tab.Pane>

            <Tab.Pane eventKey="Flights">
              <Flights data={data} />
            </Tab.Pane>

            <Tab.Pane eventKey="Stay">
              <Stay data={data} />
            </Tab.Pane>

            <Tab.Pane eventKey="Transfers">
              <Transfers data={data} />
            </Tab.Pane>


          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  );
}

export default Itinerary2;
